export const DEFAULT_PAGING_PER_PAGE = 20;

export const PAGING_PER_PAGE_NUMBERS = [10, DEFAULT_PAGING_PER_PAGE, 50, 100];
